module.exports = __webpack_public_path__ + "static/media/clock-icon-purple.c3c28194.svg";